import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SpreadsheetGuide from "@/pages/article/SpreadsheetGuide";
import BestFinds from "@/pages/article/BestFinds";
import BeginnersGuide from "@/pages/article/BeginnersGuide";
import ComparisonHub from "@/pages/article/ComparisonHub";
import KakobuyVsCSSBuy from "@/pages/article/KakobuyVsCSSBuy";
import KakobuyVsSuperbuy from "@/pages/article/KakobuyVsSuperbuy";
import KakobuyVsOopbuy from "@/pages/article/KakobuyVsOopbuy";
import DownloadPage from "@/pages/article/DownloadPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <SpreadsheetGuide />,
  },
  {
    path: "/kakobuy-spreadsheet-finds",
    element: <BestFinds />,
  },
  {
    path: "/kakobuy-spreadsheet-beginners",
    element: <BeginnersGuide />,
  },
  {
    path: "/spreadsheet-comparison",
    element: <ComparisonHub />,
  },
  {
    path: "/kakobuy-vs-cssbuy",
    element: <KakobuyVsCSSBuy />,
  },
  {
    path: "/kakobuy-vs-superbuy",
    element: <KakobuyVsSuperbuy />,
  },
  {
    path: "/kakobuy-vs-oopbuy",
    element: <KakobuyVsOopbuy />,
  },
  {
    path: "/kakobuy-spreadsheet-download",
    element: <DownloadPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;